const toFiniteNumber = (value, fallback = 0) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

export function calculateHotelPoints(room, nights, factor) {
  const normalizedFactor = toFiniteNumber(factor);
  if (!room || normalizedFactor <= 0) {
    return { daily: 0, tax: 0, total: 0 };
  }

  const normalizedNights = Math.max(1, toFiniteNumber(nights, 1));
  const daily = Math.ceil(
    (toFiniteNumber(room.markedupDailyFare?.value) * normalizedNights) /
      normalizedFactor,
  );
  const tax = Math.ceil(
    (toFiniteNumber(room.dailyTax?.value) * normalizedNights) /
      normalizedFactor,
  );

  return { daily, tax, total: daily + tax };
}

export function resolveEffectiveMoneyToPay({
  cashOnly,
  checkoutType,
  hotelTotal,
  airfareTotal,
  orderTotal,
  couponApplied,
  couponMoney,
  moneyValue,
}) {
  if (cashOnly) {
    const totalByCheckout = {
      hotel: hotelTotal,
      airfare: airfareTotal,
      order: orderTotal,
    };

    return Math.max(
      0,
      toFiniteNumber(totalByCheckout[checkoutType] ?? orderTotal),
    );
  }

  return Math.max(
    0,
    toFiniteNumber(couponApplied ? couponMoney : moneyValue),
  );
}

export function normalizeHotelCheckoutData(hotelData, cashOnly) {
  return {
    ...hotelData,
    hotels: (hotelData?.hotels || []).map((hotel) => ({
      ...hotel,
      description: hotel.description || hotel.name || "",
      address: hotel.address
        ? {
            ...hotel.address,
            longitude: String(hotel.address.longitude || ""),
            latitude: String(hotel.address.latitude || ""),
          }
        : hotel.address,
      rooms: (hotel.rooms || []).map((room) => ({
        ...room,
        amount: {
          ...room.amount,
          ...(cashOnly ? { points: 0 } : {}),
        },
        description: room.description || room.name || "",
        dailyFare: room.dailyFare || { value: 0, currencyCode: "BRL" },
        markedupDailyFare:
          room.markedupDailyFare ||
          room.dailyFare || { value: 0, currencyCode: "BRL" },
        originalDailyFare:
          room.originalDailyFare ||
          room.dailyFare || { value: 0, currencyCode: "BRL" },
        dailyTax: room.dailyTax || { value: 0, currencyCode: "BRL" },
        originalDailyTax:
          room.originalDailyTax ||
          room.dailyTax || { value: 0, currencyCode: "BRL" },
        dailyFareDiscount: room.dailyFareDiscount || { value: 0 },
      })),
    })),
  };
}
